// extracted by mini-css-extract-plugin
export default {"img_circle":"Profile_img_circle__7lyKx","label_choosefile":"Profile_label_choosefile__S-UZT","custom_two_colum":"Profile_custom_two_colum__tzw21","error":"Profile_error__gOIAB"};